import * as React from "react";
import { useSelector } from "react-redux";
import { Spinner } from "@fluentui/react/lib/Spinner";
import { Checkbox } from "@fluentui/react/lib/Checkbox";
import { Icon } from "@fluentui/react/lib/Icon";
import InfiniteScroll from "react-infinite-scroll-component";

import { setSelectedAttributeData } from "../utils";
import { TEXT } from "../../../shared/constants/texts";

type AttributeListingProps = {
  clearClicked: any;
  searchClicked: any;
};

const AttributeListing: React.FC<AttributeListingProps> = (props) => {
  const { clearClicked, searchClicked } = props;
  const state = useSelector((state: any) => state.attachFromIciSlice);
  const { isFetchingAttributeData, attributeData, selectedAttributes } = state;
  const [attributes, setAttributes] = React.useState(attributeData);
  const searchAttributeRef = React.useRef(null);

  React.useEffect(() => {
    if (attributeData.length > 0) {
      setAttributeData(attributeData);
    }
  }, []);

  React.useEffect(() => {
    setAttributeData(attributeData);
  }, [attributeData]);

  React.useEffect(() => {
    setAttributeData(attributeData);
  }, [selectedAttributes]);

  const setAttributeData = (data) => {
    const attrData = [...attributeData];
    let selectedAttrData = [];
    let nonSelectedAttrData = data;
    if (selectedAttributes.length > 0) {
      selectedAttrData = attrData.filter((attr) => selectedAttributes.includes(attr.attributeId));
      nonSelectedAttrData = data.filter((attr) => !selectedAttributes.includes(attr.attributeId));
    }
    if (searchAttributeRef && searchAttributeRef.current && searchAttributeRef.current.value) {
      const searchTerm = searchAttributeRef.current.value;
      nonSelectedAttrData = nonSelectedAttrData.filter((attr) =>
        attr.displayName.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }
    setAttributes(selectedAttrData.concat(nonSelectedAttrData));
  };

  const onAttributeClicked = (data) => {
    let selectedAttrs = [...selectedAttributes];
    if (!selectedAttributes.includes(data.attributeId)) {
      selectedAttrs.push(data.attributeId);
    } else {
      selectedAttrs = selectedAttrs.filter((attrId) => attrId !== data.attributeId);
    }
    setSelectedAttributeData(selectedAttrs);
  };

  const onChangeSearchAttribute = (e) => {
    e.preventDefault();
    const searchTerm = searchAttributeRef.current.value;
    if (searchTerm.length === 0) {
      setAttributeData(attributeData);
    } else {
      const attrData = attributeData.filter((attr) =>
        attr.displayName.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setAttributeData(attrData);
    }
  };

  const onAttributeCrossIconClicked = () => {
    if (searchAttributeRef && searchAttributeRef.current && searchAttributeRef.current.value) {
      searchAttributeRef.current.value = "";
      setAttributeData(attributeData);
    }
  };

  const onClearClicked = () => {
    setSelectedAttributeData([]);
    onAttributeCrossIconClicked();
    clearClicked();
  };

  const onSearchClicked = () => {
    searchClicked();
  };

  return (
    <div className="attribute-listing-container-attach-from-ici">
      <div className="search-only">
        <p>{TEXT.SEARCH_ONLY_IN}</p>
      </div>
      <div className="search-box-attach-from-ici">
        <input
          ref={searchAttributeRef}
          type="text"
          placeholder={TEXT.PLACEHOLDER_SEARCH_ATTRIBUTES}
          onChange={(e) => onChangeSearchAttribute(e)}
        />
        {searchAttributeRef && searchAttributeRef.current && searchAttributeRef.current.value ? (
          <div className="cross-search-icon">
            <Icon onClick={onAttributeCrossIconClicked} iconName="Cancel" />
            <span className="sr-only">{TEXT.CANCEL}</span>
          </div>
        ) : null}
      </div>
      <div className="attribute-list" id="id-attribute-listing-attach-from-ici">
        {isFetchingAttributeData ? (
          <LoadingAttributes />
        ) : attributes && attributes.length > 0 ? (
          <div>
            <InfiniteScroll
              dataLength={attributes.length}
              next={() => {}}
              hasMore={false}
              loader={
                <div className="attribute-loader-container-is-attach-from-ici">
                  <Spinner label={TEXT.LOADING_ATTRIBUTES} labelPosition="right" />
                </div>
              }
              endMessage={
                <div className="attribute-end-message-container-is-attach-from-ici">
                  <p>{TEXT.END_OF_THE_ATTRIBUTE_LIST}</p>
                </div>
              }
              scrollableTarget="id-attribute-listing-attach-from-ici"
            >
              {attributes.map((attribute) => {
                return (
                  <div className="single-attribute-container" key={attribute.id}>
                    <Checkbox
                      styles={{
                        checkbox: {
                          width: "1rem",
                          height: "1rem",
                          marginTop: "0.125rem",
                          backgroundColor: "#fff",
                        },
                        checkmark: {
                          backgroundColor: "#0078d7",
                        },
                        text: {
                          fontSize: "0.8125rem",
                          color: "#666",
                          wordWrap: "break-word",
                          width: "75vw",
                        },
                      }}
                      label={attribute.displayName}
                      checked={selectedAttributes.includes(attribute.attributeId)}
                      onChange={() => onAttributeClicked(attribute)}
                    />
                  </div>
                );
              })}
            </InfiniteScroll>
          </div>
        ) : (
          <EmptyAttributes />
        )}
      </div>
      <div className="button-container">
        <button onClick={onClearClicked}>{TEXT.CLEAR}</button>
        <button onClick={onSearchClicked}>{TEXT.SEARCH}</button>
      </div>
    </div>
  );
};

const LoadingAttributes = () => {
  return (
    <div className="attribute-listing-loading-container-attach-from-ici">
      <Spinner label={TEXT.LOADING_ATTRIBUTES} labelPosition="right" />
    </div>
  );
};

const EmptyAttributes = () => {
  return (
    <div className="attribute-listing-empty-container-attach-from-ici">
      <p>{TEXT.NO_ATTRIBUTES_FOUND}</p>
    </div>
  );
};

export default AttributeListing;
